export default "__VITE_ASSET__CP_xCBHl__"